import React from 'react'
import { WidgetGallery } from '../../../../../common/types/api/page'
import { DashboardWidget } from '../../../../../common/types/api/DashboardsResponse'

export function WidgetDescription({
    dashboardWidget,
    widget
}: {
    widget: WidgetGallery
    dashboardWidget: DashboardWidget
   }) {
    return (
        <>  
            <span className="widgetGallery--grid__widgetContainer--title">
                {dashboardWidget?.title?.toUpperCase() || 'Select Widget'}
            </span>
            {widget?.height >= 150 && widget?.width > 150 &&
                <>
                    <span>
                        Size:{' '}
                        <strong>
                            {widget.height} x {widget.width} px
                        </strong>
                    </span>
                    <span>
                        Widget: <strong>{widget.widgetId}</strong>
                    </span>
                    <span>
                        Dashboard: <strong>{dashboardWidget?.dashboard?.name || '--|--'}</strong>
                    </span>
                    <span>
                        Id: <strong>{widget.id}</strong>
                    </span>
                    <span>
                        Timespan: <strong>{widget.span}</strong>
                    </span>
                </>
            }
        </>
    )
}
